import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { AI_ROUTES } from '#modules/ai-settings/routes/ai-settings.routing';
import { AUTOMATIONS_ROUTES } from '#modules/automations/routes/automations.routing';
import { PLATFORMS_ROUTES } from '#modules/platforms/routing/platforms.routing';
import { USERS_ROLES_ROUTES } from '#modules/user/routes/users-roles.routing';

export const SETTINGS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/settings-layout/settings-layout.component').then(
                (m) => m.SettingsLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'platforms',
            },
            {
                path: 'platforms',
                loadChildren: () => PLATFORMS_ROUTES, // sync import to avoid issue with lazy loading. See https://malou.sentry.io/issues/4525057545/?environment=development&project=4504751295430656&query=is%3Aunresolved&referrer=issue-stream&statsPeriod=1h&stream_index=1
                data: { routePath: RoutePath.PLATFORMS },
            },
            {
                path: 'ai',
                loadChildren: () => AI_ROUTES,
                data: { routePath: RoutePath.AI },
            },
            {
                path: 'automations',
                loadChildren: () => AUTOMATIONS_ROUTES,
                data: { routePath: RoutePath.AUTOMATIONS },
            },
            {
                path: 'roles',
                loadChildren: () => USERS_ROLES_ROUTES,
                data: { routePath: RoutePath.USERS },
            },
        ],
    },
];
